var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset", "background-color": "#f5f7f7" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/landing/logo_black.png",
            searchImgSrc: "../../../../static/img/landing/search_black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c(
            "main",
            {
              staticClass: "st-MainContents",
              staticStyle: { "padding-top": "120px" }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("section", { staticClass: "policy-Block p-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12",
                    staticStyle: { border: "1px solid #1c1c1c" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          margin: "50px 20px 10px 20px",
                          padding: "30px 20px",
                          border: "2px solid #1c1c1c"
                        }
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "el-form",
                          {
                            ref: "emailForm",
                            staticClass: "demo-emailForm",
                            attrs: {
                              model: _vm.emailForm,
                              rules: _vm.rules,
                              "label-width": "0px",
                              method: "post",
                              action: ""
                            }
                          },
                          [
                            _c("div", { staticClass: "col-12 pt-5 m-0" }, [
                              _c("div", { staticClass: "col-12 m-0" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "loginLabelText",
                                    attrs: { for: "name" }
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c("h2", { staticClass: "mb-0" }, [
                                        _vm._v("お名前")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "h1",
                                        {
                                          staticClass: "mb-0",
                                          staticStyle: {
                                            "margin-top": "3px",
                                            "margin-left": "10px"
                                          }
                                        },
                                        [_vm._v("*")]
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 pl-0 pr-0" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "col-12 p-0",
                                      attrs: { prop: "name" }
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "m-0",
                                        attrs: {
                                          type: "text",
                                          "auto-complete": "on",
                                          id: "name",
                                          name: "name",
                                          placeholder: ""
                                        },
                                        model: {
                                          value: _vm.emailForm.name,
                                          callback: function($$v) {
                                            _vm.$set(_vm.emailForm, "name", $$v)
                                          },
                                          expression: "emailForm.name"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 pt-4 mb-6" }, [
                              _c("div", { staticClass: "col-12 m-0" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "loginLabelText",
                                    attrs: { for: "email" }
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c("h2", { staticClass: "mb-0" }, [
                                        _vm._v("メールアドレス")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "h1",
                                        {
                                          staticClass: "mb-0",
                                          staticStyle: {
                                            "margin-top": "3px",
                                            "margin-left": "10px"
                                          }
                                        },
                                        [_vm._v("*")]
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 pl-0 pr-0" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "col-12 p-0",
                                      attrs: { prop: "email" }
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "m-0",
                                        attrs: {
                                          "auto-complete": "on",
                                          id: "email",
                                          name: "email",
                                          placeholder: ""
                                        },
                                        model: {
                                          value: _vm.emailForm.email,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailForm,
                                              "email",
                                              $$v
                                            )
                                          },
                                          expression: "emailForm.email"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 pt-0" }, [
                              _c("div", { staticClass: "col-12 m-0 mb-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "loginLabelText",
                                    attrs: { for: "message" }
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c("h2", { staticClass: "mb-0" }, [
                                        _vm._v("本文")
                                      ])
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 pl-0 pr-0" },
                                [
                                  _c(
                                    "el-form-item",
                                    { staticClass: "col-12 p-0" },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 12,
                                          id: "message",
                                          name: "message"
                                        },
                                        model: {
                                          value: _vm.emailForm.message,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.emailForm,
                                              "message",
                                              $$v
                                            )
                                          },
                                          expression: "emailForm.message"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { margin: "10px 20px 30px 20px" },
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitEmailForm("emailForm")
                          }
                        }
                      },
                      [_vm._v("送信")]
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm._m(2)
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "news-PageTitle mb-5" }, [
      _c("div", { staticClass: "news-PageTitle_Inner" }, [
        _c(
          "h1",
          {
            staticClass: "sw-Section_Header appear",
            attrs: { "data-appear": "" }
          },
          [
            _c("span", { staticClass: "sw-Section_Header-en" }, [
              _c("b", [_vm._v("Contact Us")])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sw-Section_Header-ja" }, [
              _c("b", [_vm._v("お問い合わせ")])
            ]),
            _vm._v(" "),
            _c("br")
          ]
        ),
        _vm._v(" "),
        _c("h2", { staticStyle: { "font-weight": "unset" } }, [
          _vm._v(
            "弊社に興味をお持ちいただきありがとうございます。\n              "
          ),
          _c("br"),
          _vm._v(
            "\n              お問い合わせいただきました内容は、弊社の掲げる個人情報保護方針に沿って管理し、お客様の同意なく第三者に開示・提供することはございません。\n              "
          ),
          _c("br"),
          _vm._v(
            "\n              詳細につきましては、当サイトの「プライバシーポリシー」をご参照ください。\n              "
          ),
          _c("br")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "m-0",
        staticStyle: {
          "justify-content": "center",
          display: "flex",
          "align-items": "center"
        }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              border: "2px solid #1c1c1c",
              padding: "5px 15px",
              "font-size": "1.8em",
              background: "#56d0bb",
              color: "#fff",
              margin: "-59px 0px 0px 0px"
            }
          },
          [_vm._v("お問い合わせ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "st-Breadcrumbs" }, [
      _c(
        "ul",
        {
          staticClass: "st-BreadcrumbsList",
          attrs: { itemscope: "itemscope", itemtype: "" }
        },
        [
          _c(
            "li",
            {
              staticClass: "st-BreadcrumbsList_Item",
              attrs: {
                itemprop: "itemListElement",
                itemscope: "itemscope",
                itemtype: ""
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "st-BreadcrumbsList_Item-link",
                  attrs: { href: "/", itemprop: "item" }
                },
                [_vm._v("ホーム")]
              ),
              _vm._v(" "),
              _c("meta", { attrs: { itemprop: "position", content: "1" } })
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "st-BreadcrumbsList_Item",
              attrs: {
                itemprop: "itemListElement",
                itemscope: "itemscope",
                itemtype: ""
              }
            },
            [
              _c(
                "p",
                {
                  staticStyle: { "margin-bottom": "0rem" },
                  attrs: { itemprop: "item", "aria-current": "page" }
                },
                [
                  _c("span", { attrs: { itemprop: "name" } }, [
                    _vm._v("お問い合わせ")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("meta", { attrs: { itemprop: "position", content: "3" } })
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6563fd02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6563fd02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contactus/contactus.vue
// module id = null
// module chunks = 